import { Autocomplete } from 'components';
import React, { useEffect, useState } from 'react';
import SubCategoryServices from 'services/SubCategoryServices';


/**
 * AutocompleteField - Themed, reusable autocomplete component with validation, using TextValidator as input.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */

const SubCategories = ({
    name,
    label,
    value,
    onChange,
    filter,
    categoryId,
    required = false,
    validators = [],
    errorMessages = [],
    disabled = false,
}) => {

    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({...filter, search: null,status:'Active', category_id: categoryId });

    useEffect(() => {
    setFilters((prev) => ({ ...prev, ...(filter || {}), search: filter?.search ?? null, status: filter?.status ?? 'Active', category_id: categoryId ?? filter?.category_id ?? prev.category_id }));
}, [filter, categoryId]);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const [data] = await Promise.all([
                    SubCategoryServices.getAll({ ...filters }),
                ]);
                setData(
                  data?.data?.view?.data ||
                  data?.data?.subcategories?.data ||
                  data?.data?.data ||
                  []
                );
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [filters]);



    // Determine the selected value for the Autocomplete. The parent may pass the
    // entire object or just the id/value. Try to resolve to the object from `data`.
    const resolvedValue = (() => {
        if (!value) return null;
        if (typeof value === 'object') return value;
        return data.find((item) => String(item.id) === String(value)) || null;
    })();

    return (
        <div>
            <Autocomplete
                name={name}
                label={label}
                value={resolvedValue}
                onChange={(event, newValue) => {
                    if (onChange) onChange(event, newValue);
                }}
                options={data}
                getOptionLabel={option => option?.name || option?.label || ''}
                textInputOnChange={(e) => {
                    setFilters({ ...filters, search: e.target.value })
                }}
                //isOptionEqualToValue={(option, value) => option?.id === value?.id || option?.value === value?.value}
                required={required}
                validators={validators}
                errorMessages={errorMessages}
                disabled={disabled}
            />
        </div>
    );
};

export default SubCategories ;
